<template>
    <div class="fixed-bottom bg-primary">
        <div class="container text-white text-center p-3 sm-text">
            &copy; {{ year }} Titan International
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        year () {
            const date = new Date()
            return date.getFullYear()
        }
    }
}
</script>
